import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, TableCell } from "@mui/material"
import { BlockClicks } from "lib/@components/block-clicks"
import { useState } from "react"

export function AuthoringUserMultiSelectCell({
    label,
    options = [],
    selectedIds = [],
    onToggle,
    dataCy,
    inputId,
    className,
}) {
    const [open, setOpen] = useState(false)

    return (
        <TableCell align="right" sx={{ textTransform: "capitalize" }}>
            <BlockClicks>
                <FormControl
                    fullWidth
                    sx={{
                        m: 1,
                        minWidth: 225,
                        maxWidth: { sm: 225 },
                        textAlign: "left",
                    }}
                >
                    <InputLabel size="small" id={inputId}>
                        {label}
                    </InputLabel>
                    <Select
                        data-cy={dataCy}
                        labelId={inputId}
                        className={className}
                        multiple
                        size="small"
                        open={open}
                        onClick={handleClick}
                        value={selectedIds}
                        input={<OutlinedInput label={label} />}
                        MenuProps={{
                            sx: { "& .MuiPaper-root": { maxHeight: 260 }, textAlign: "left" },
                        }}
                    >
                        {options.map(renderOption)}
                    </Select>
                </FormControl>
            </BlockClicks>
        </TableCell>
    )

    function handleClick() {
        setOpen((prev) => !prev)
    }

    function renderOption(option) {
        return (
            <MenuItem
                key={option.id}
                value={option.id}
                onClick={handleOptionClick(option)}
                sx={{
                    mx: 1,
                    my: 0.5,
                    borderRadius: 0.75,
                    typography: "body2",
                    textTransform: "capitalize",
                }}
            >
                {option.name}
            </MenuItem>
        )
    }

    function handleOptionClick(option) {
        return async function onOptionClick() {
            await onToggle(option)
            setOpen(false)
        }
    }
}
